import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material';
import { Button, Input, Col, DatePicker, Divider, Flex, Modal, Row, Select, Table, Tag, Tooltip, Typography, Image } from 'antd';
import dayjs from 'dayjs';
import AuthService from '../../Components/auth/AuthService';
import { hideLoading, showLoading, useLoadingDispatch } from '../../context/loadingContext';
import { deliveryStatuses, StockReturnReasons, userRolesTypes } from '../../Components/common/Constants';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, CloseOutlined, InfoCircleTwoTone } from '@ant-design/icons';
import ProductInfoModal from '../../Components/Modals/ProductInfoModal';
import { useSelector } from 'react-redux';
import { showMessage } from '../../Components/Utils/message';
import { env, netsuite_url, wms_uploads_cdn } from '../../Components/config';
import { Button as UploadButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { encodeId, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from '../../Components/common/CommonFun';

const Auth = new AuthService();
const DataSheet = styled('div')`
    .ant-select .ant-select-selector {
      border-bottom: 1px solidrgb(203, 195, 195);
      border-top: 0px !important;
      border-left: 0px;
      border-right: 0px;
      border-radius: 0px
    }
    .ant-input-disabled {
      background: none;
      color: black;
      fontWeight: 500;
    }
`;

const RouteInventoryAdjustment = () => {
    const { TextArea } = Input;
    const { Text, Title } = Typography;
    const { locations, products, roles } = useSelector((state) => state?.AppState?.userCreds);
    const hasRole5 = roles?.some(r => r.role_id === 5);

    const navigate = useNavigate();
    const layoutDispatch = useLoadingDispatch()
    const [deliveryDate, setDeliveryDate] = useState(dayjs());
    const [routes, setRoutes] = useState([]);
    const allRoutesCompleted = routes?.every(route => route?.route_returned_posted_by > 0);
    const [notes, setNotes] = useState("");
    const [files, setFiles] = useState([]);
    const [currentItemFiles, setCurrentItemFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = React.useState([]);

    //Inventory Data 
    const [inventoryData, setInventoryData] = useState(null)
    const [inventoryAdjustmentInternalID, setInventoryAdjustmentInternalID] = useState(null)
    const [inventoryAdjustmentCode, setInventoryAdjustmentCode] = useState(null)
    const [internalID, setInternalID] = useState(null)
    const [internalCode, setInternalCode] = useState(null)
    const [inventoryPostDate, setInventoryPostDate] = useState(null)
    const [selectedDates, setSelectedDates] = useState(null);

    const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
    const [selectedProductDetails, setSelectedProductDetails] = useState({
        totalStock: 0,
        code: '',
        name: '',
        productDetails: [],
        selectedRecord: null
    });

    const UserType = useSelector((state) => state.AppState?.userCreds?.type);
    const matchedRoles = roles
        .map((role) => {
            return userRolesTypes.find((userRole) => userRole.id === role.role_id);
        })
        .filter(Boolean);

    const includesFinance = matchedRoles.some((item) => item.title === "Finance");

    const loadRoutes = async () => {
        showLoading(layoutDispatch)
        try {
            const routeRes = await Auth.post(`/route/load-locked-routes`, {
                delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
            })
            if (routeRes.ack) {
                setRoutes(routeRes?.routes)
                const data = { status: true, routes: routeRes?.routes };
                return data
            } else {
                showMessage('error', routeRes?.message)
                hideLoading(layoutDispatch)
                return false;

            }
        } catch (err) {
            showMessage('error', 'something went wrong')
            hideLoading(layoutDispatch)
            return false;
        }
    };
    const getInventoryData = async () => {
        showLoading(layoutDispatch)
        const routesStatus = await loadRoutes()
        if (routesStatus?.status) {
            try {
                const response = await Auth.post(`/route/load-inventory-adjustments`, {
                    delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
                })
                if (response?.ack) {
                    // const newGroup = groupByItemId(response?.inventory_adjustments, routesStatus?.routes)
                    if (response.posted) {
                        setNotes(response?.daily_route?.inventory_adjustment_notes)
                        setCurrentItemFiles(response?.daily_route?.inventory_adjustment_files ? JSON.parse(response?.daily_route?.inventory_adjustment_files) : [])
                        setInventoryPostDate(response?.daily_route?.inventory_adjustment_posted_date ? dayjs(response?.daily_route.inventory_adjustment_posted_date).format('YYYY-MM-DD') : null)
                        setInventoryAdjustmentInternalID(response?.daily_route?.inventory_adjustment_internal_id)
                        setInventoryAdjustmentCode(response?.daily_route?.inventory_adjustment_code);
                        setInternalID(response?.daily_route?.wms_inventory_adjustment_id)
                        setInternalCode(response?.daily_route?.wms_inventory_adjustment_code)
                    } else {
                        setNotes("")
                        setCurrentItemFiles([])
                        setInventoryPostDate(null)
                        setFiles([])

                    }

                    const updatedItems = response?.inventory_adjustments?.map((item) => {
                        const damages = Number(item?.returned_quantity) - Number(item?.returned_quantity_to_stock);
                        const orReturned = Number(item?.packed_quantity) - Number(item?.delivered_quantity)
                        const damages_posted = item?.returned_quantity_posted ? item?.returned_quantity_posted : Number(orReturned) - Number(item?.returned_quantity_to_stock)

                        return {
                            ...item,
                            damages: damages,
                            returned_quantity_to_damages_posted: damages_posted,
                        };
                    });

                    const data = {
                        posted: response?.posted,
                        inventory_adjustments: updatedItems,
                    }
                    setInventoryData(data);
                }
                else {
                    showMessage('error', response.message);
                }
            } catch (err) {
                showMessage('error', 'something went wrong')
            } finally {
                hideLoading(layoutDispatch)
            }
        } else {
            showMessage('error', 'Failed to load routes. Try again!')
        }
    };

    useEffect(() => {
        const initialDates = inventoryData?.posted ? inventoryPostDate : deliveryDate

        setSelectedDates(initialDates);
    }, [inventoryData]);

    const submitImage = (e) => {
        e.persist?.();
        handleSubmitImage(e, setFiles, setCurrentItemFiles)
    }

    const handleRetryInventoryAdjustments = async () => {
        
        showLoading(layoutDispatch)
        const dataToSend = {
            delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
            posting_date: dayjs(selectedDates).format("YYYY-MM-DD"),
            
        };
        // const emailPayload = {
        //   deliveryDate: deliveryDate,
        //   inventoryAdjustments: inventoryData?.inventory_adjustments,
        //   notes: notes,
        //   files: currentItemFiles.map(
        //     (file) => `${wms_uploads_cdn}/${env}/ss/${deliveryDate}/${file.replace(/\+/g, '%2B')}`
        //   ),

        // }

        try {
            const response = await Auth.fetch("/route/retry-save-inventory-adjustments", {
                method: "POST",
                body: JSON.stringify(dataToSend),
            });
            if (response.ack) {
                const uploadPromises = []
                if (files.length > 0) {
                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'inventory-adjustments', dayjs(deliveryDate).format('YYYY-MM-DD'))
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);

                showMessage('success', response?.message)
                getInventoryData()

                //Production url and token for email
                // if (env === 'prod') {
                //   const EmailApiResponse = await fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/s", {
                //     method: "POST",
                //     headers: {
                //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                //       "Content-Type": "application/json"
                //     },
                //     body: JSON.stringify(emailPayload)
                //   });
                //   if (EmailApiResponse.ok === true) {


                //     setLoadMessage("Email sent ")
                //     setType('success')
                //   } else {
                //     setLoadMessage("Email Sendind Failure")
                //     setType('error')
                //   }
                // } else {
                //   const EmailApiResponse = await fetch("http://localhost:7420/api/email/s", {
                //     method: "POST",
                //     headers: {
                //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                //       "Content-Type": "application/json"
                //     },
                //     body: JSON.stringify(emailPayload)
                //   });
                //   if (EmailApiResponse.ok === true) {


                //     setLoadMessage("Email sent ")
                //     setType('success')
                //   } else {
                //     setLoadMessage("Email Sendind Failure")
                //     setType('error')
                //   }
                // }


            } else {
                showMessage('error', response?.message)
                hideLoading(layoutDispatch)
            }
        } catch (error) {
            console.log(error);
            showMessage('error', 'something went wrong')
            hideLoading(layoutDispatch)

        }
    };

    const handleSubmit = async () => {

        const payload = inventoryData?.inventory_adjustments?.map(item => ({
            product_netsuite_id: item?.product_netsuite_id,
            purchase_order_details_batch_id: item?.purchase_order_details_batch_id,
            batch_code: item?.batch_code,
            supplier_batch_code: item?.supplier_batch_code,
            expiry_date: item?.expiry_date,
            returned_quantity_posted: item?.returned_quantity_to_damages_posted,
            item_pallet_id: item?.item_pallet_id,
            id: item?.id,
        }));

        showLoading(layoutDispatch)

        const dataToSend = {
            delivery_date: dayjs(deliveryDate).format("YYYY-MM-DD"),
            inventory_adjustments: payload,
            posting_date: dayjs(selectedDates).format("YYYY-MM-DD"),
            notes: notes,
            files: currentItemFiles,
        };
        // const emailPayload = {
        //   deliveryDate: deliveryDate,
        //   inventoryAdjustments: inventoryData?.inventory_adjustments,
        //   notes: notes,
        //   files: currentItemFiles.map(
        //     (file) => `${wms_uploads_cdn}/${env}/inventory-adjustments/${deliveryDate}/${file.replace(/\+/g, '%2B')}`
        //   ),

        // }
        console.log('dataToSend', dataToSend);


        try {
            const response = await Auth.fetch("/route/save-inventory-adjustments", {
                method: "POST",
                body: JSON.stringify(dataToSend),
            });
            if (response.ack) {
                const uploadPromises = []
                if (files.length > 0) {
                    files.forEach((f) => {
                        uploadPromises.push(
                            getUploadUrl(f, 'inventory-adjustments', dayjs(deliveryDate).format('YYYY-MM-DD'))
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                        );
                    });
                }
                await Promise.all(uploadPromises);

                showMessage("success", response?.message);
                getInventoryData()

                //Production url and token for email
                // if (env === "prod") {
                //   fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/inventory-adjustment", {
                //     method: "POST",
                //     headers: {
                //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                //       "Content-Type": "application/json",
                //     },
                //     body: JSON.stringify(emailPayload),
                //   }).catch((err) => console.error("Error sending email:", err));
                // } else if (env === "dev") {

                //   fetch("http://localhost:7420/api/email/inventory-adjustment", {
                //     method: "POST",
                //     headers: {
                //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                //       "Content-Type": "application/json",
                //     },
                //     body: JSON.stringify(emailPayload),
                //   }).catch((err) => console.error("Error sending email:", err));
                // } else {
                //   fetch("http://34.197.161.10:7420/api/email/inventory-adjustment", {
                //     method: "POST",
                //     headers: {
                //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
                //       "Content-Type": "application/json",
                //     },
                //     body: JSON.stringify(emailPayload),
                //   }).catch((err) => console.error("Error sending email:", err));
                // }

            } else {
                showMessage('error', response.message);
                hideLoading(layoutDispatch)

            }
        } catch (error) {
            console.log(error);
            showMessage('error', 'something went wrong')
            hideLoading(layoutDispatch)
        }
    };


    const handleModalCancelProduct = () => {
        setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: '', name: '', productDetails: [], selectedRecord: null });
        setModalVisibleProduct(false);
    }

    const handleInfoClick = async (record) => {
        const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
        showLoading(layoutDispatch)
        try {

            const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
            if (res?.ack) {
                if (res?.product_details.length > 0) {
                    const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
                    setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name: product?.name, productDetails: res?.product_details, selectedRecord: product });
                    setModalVisibleProduct(true);
                    hideLoading(layoutDispatch)

                } else {
                    showMessage('error', 'No Details');
                    hideLoading(layoutDispatch)
                }
            } else {
                setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name: product?.name, productDetails: [] });
                showMessage('error', res?.message)
                hideLoading(layoutDispatch)

            }

        } catch (error) {
            showMessage('error', 'something went wrong');
            hideLoading(layoutDispatch)
        }
    };

    const handleInputChange = (value, index) => {
        if (value.includes('.')) return;
        const updatedInventoryAdjustments = [...inventoryData.inventory_adjustments];
        updatedInventoryAdjustments[index].returned_quantity_to_damages_posted = value;

        // Update the state with the new adjustments
        setInventoryData({
            ...inventoryData,
            inventory_adjustments: updatedInventoryAdjustments
        });
    };

    const dataCol = [
        {
            title: "Item",
            render: (text, record) => {
                const selectedProduct = products?.find(item => item.netsuite_id === record?.product_netsuite_id)
                return (
                    <Flex gap={5} align="center">
                        <Tooltip title={'Product Info'}>
                            <InfoCircleTwoTone
                                style={{ fontSize: '22px', cursor: 'pointer', padding: '2px' }}
                                onClick={() => handleInfoClick(record)}
                            />
                        </Tooltip>
                        <span>{`${selectedProduct?.code} - ${selectedProduct?.name}`}</span>
                    </Flex>
                );
            },
            // width: 80,
        },

        {
            title: "Batch Code",
            dataIndex: "supplier_batch_code",
            key: "supplier_batch_code",
            // width: 80,
            align: 'center'
        },
        {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },

        {
            title: "Ordered QTY",
            dataIndex: "org_quantity",
            key: "org_quantity",
            // width: 80,
            align: 'center'
        },
        {
            title: "Packed QTY",
             render: (text, record) => {
                return (
                    <span>
                        <>{record?.packed_quantity ? Number(record?.packed_quantity) : 0}</>
                    </span>
                );
            },
            align: 'center'
        },
        {
            title: "Delivered QTY",
            dataIndex: "delivered_quantity",
            key: "delivered_quantity",
            // width: 80,
            align: 'center'

        },
        {
            title: "Returned QTY",
            render: (text, record) => {
                return (
                    <span>

                        <>{Number(record?.packed_quantity) - Number(record?.delivered_quantity)}</>
                    </span>
                );
            },
            // width: 80,
            align: 'center'

        },
        {
            title: "Warehouse Received QTY (Quarantine)",
            dataIndex: "returned_quantity",
            key: "returned_quantity",
            // width: 80,
            align: 'center'

        },
        {
            title: "Returned To Stock QTY",
            // dataIndex: "returned_quantity_to_stock",
            // key: "returned_quantity_to_stock",
            render: (text, record) => {
                const value = record?.returned_quantity_to_stock || 0;
                return (
                    <span>
                       {value}
                    </span>
                );
            },
            // width: 80,
            align: 'center'

        },
        {
            title: "Damages",
            render: (text, record) => {
                const value = record?.damages || 0;
                return (
                    <span>
                        {value > 0 ? (
                            <Tag color="red">{value}</Tag>
                        ) : (
                            <span>{value}</span>
                        )}
                    </span>
                );
            },
            // width: 100,
            align: "center",
        },

        {
            title: "Damages Posted",
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.returned_quantity_to_damages_posted}
                    onChange={(e) => handleInputChange(e.target.value, index)}
                    // disabled={inventoryData?.posted}
                    disabled
                />
            ),
            // width: 150,
            align: 'center'
        }
    ];

    return (
        <DataSheet>
            <Flex justify='space-between' wrap gap={5}>
                <h3 style={{ margin: 0 }}>Route Inventory Adjustments</h3>
                <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
            </Flex>

            <Flex gap={5} style={{ marginTop: 3 }} wrap>
                <DatePicker
                    format="DD-MM-YYYY"
                    value={deliveryDate}
                    onChange={(date) => setDeliveryDate(date ? dayjs(date, 'YYYY-MM-DD') : null)}
                    placeholder="Select Date"
                />
                <Button type="primary" onClick={getInventoryData}>
                    Load Inventory Adjustments
                </Button>
            </Flex>

            <Flex justify='end' align='center' gap={5} style={{ marginTop: 1 }} wrap>

                   {(inventoryData?.posted &&
                        (internalID && <Tag
                            onClick={() => navigate(`/transaction-inventory/${encodeId(internalID)}`)}
                            color="blue"
                            style={{ cursor: 'pointer', fontWeight: 'bold', padding: '4px 4px', fontSize: '16px', marginRight: '0px' }}
                        >
                            <span>
                                Inventory Adjustment:{internalCode ? ` ${internalCode}` : ''}
                            </span>
                        </Tag>)
                    )}

                    

                    {((inventoryData?.posted && !hasRole5) && 
                        (inventoryAdjustmentInternalID && <Link
                            to={`${netsuite_url}/app/accounting/transactions/invadjst.nl?id=${inventoryAdjustmentInternalID}&whence=`}
                            target="_blank"
                        >
                            <span>
                                View Inventory Adjustment {inventoryAdjustmentCode ? `(${inventoryAdjustmentCode})` : ''}
                            </span>
                        </Link>)
                    )}
                    {(inventoryData?.posted &&
                        (!inventoryAdjustmentInternalID && <Button
                            onClick={() => {
                                Modal.confirm({
                                    title: 'Post Inventory Adjustments',
                                    centered: true,
                                    content: `Are you sure to post inventory adjustments?`,
                                    onOk: () => handleRetryInventoryAdjustments(),
                                    okText: 'Post',
                                    width: 600,
                                    okButtonProps: { size: "large" },
                                    cancelButtonProps: { size: "large" },
                                });
                            }}
                            type="primary"
                        >
                            Retry Post to Netsuite
                        </Button>)
                    )}
            </Flex>


            {inventoryData?.inventory_adjustments.length > 0 && (
                <>
                    <div className="view-page">
                        <Table
                            style={{ marginTop: "10px" }}
                            scroll={{ x: 'max-content' }}
                            columns={dataCol}
                            dataSource={inventoryData?.inventory_adjustments}
                            pagination={false}
                        />
                        <Divider style={{ height: "2px", background: "#006cb8" }} />
                        <h4 style={{ fontWeight: "bold", margin: 0 }}>Posting Date:</h4>

                        <>
                            {(!hasRole5) && (
                                <>
                                    <DatePicker
                                        format={"YYYY-MM-DD"}
                                        style={{ width: 200, marginTop: 2 }}
                                        value={
                                            selectedDates
                                                ? dayjs(selectedDates)
                                                : null
                                        }
                                        onChange={(_, dateStr) => {
                                            setSelectedDates(dateStr);
                                        }}
                                        placeholder="Select Date"
                                        // size="large"
                                        disabled={
                                            inventoryData?.posted
                                        }
                                    />
                                </>
                            )}
                        </>

                        <h4 style={{ fontWeight: "bold", marginBottom: "3px", marginTop: '3px' }}>Notes</h4>
                        <div style={{ marginBottom: "10px" }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                    <TextArea
                                        autoSize={{ minRows: 6, maxRows: 12 }}
                                        label="Notes"
                                        placeholder="Enter Any Specific Notes"
                                        onChange={(e) => setNotes(e.target.value)}
                                        value={notes}
                                        disabled={inventoryData?.posted}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <Divider />

                        <div style={{ display: 'flex' }}>
                            <UploadButton
                                component="label"
                                variant="contained"
                                sx={{ marginTop: "10px" }}
                                startIcon={<CloudUploadIcon />}
                                disabled={inventoryData?.posted}

                            >
                                Add files
                                <input
                                    type="file"
                                    hidden
                                    multiple
                                    capture
                                    accept="image/*, video/*"
                                    // onChange={(e) => {
                                    //   handleSubmitImage(e);
                                    // }}
                                    onClick={(e) => {
                                        // ensures it always triggers even if same file is picked
                                        e.target.value = "";
                                    }}
                                    onChange={(e) => {
                                        const myfiles = e.target.files;

                                        if (myfiles.length > 10) {
                                            showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                                            e.target.value = "";
                                        } else {
                                            submitImage(e);
                                        }
                                    }}
                                />
                            </UploadButton>
                        </div>
                        {currentItemFiles?.length > 0 && <h4>Old Files:</h4>}
                        <Image.PreviewGroup>
                            {currentItemFiles?.length > 0 &&
                                currentItemFiles
                                    .filter((item) => !files.some((file) => file.name === item))
                                    .map((item) => {
                                        const encodedFileName = item.replace(/\+/g, '%2B');
                                        const imageUrl = `${wms_uploads_cdn}/${env}/ss/${deliveryDate}/${encodedFileName}`;
                                        return (
                                            <div
                                                style={{
                                                    position: "relative",
                                                    marginRight: "10px",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <Image
                                                    width={200}
                                                    height={150}
                                                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                                                    src={imageUrl}
                                                />
                                                <Tooltip title="Delete">
                                                    <CloseOutlined
                                                        style={{
                                                            fontSize: "30px",
                                                            position: "absolute",
                                                            right: 5,
                                                            top: 5,
                                                            color: "#c12828",
                                                        }}
                                                        onClick={() => {
                                                            handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles)
                                                        }
                                                        }
                                                    />
                                                </Tooltip>
                                            </div>
                                        );
                                    })}
                        </Image.PreviewGroup>
                        <Divider />
                        {files?.length > 0 && <h4>New Files:</h4>}
                        <Image.PreviewGroup>
                            {files?.length > 0 &&
                                files?.map((item) => {
                                    return (
                                        <div
                                            style={{
                                                position: "relative",
                                                marginRight: "10px",
                                                display: "inline-block",
                                            }}
                                        >
                                            <Image
                                                width={200}
                                                height={150}
                                                style={{ padding: "5px", border: "1px solid lightgrey" }}
                                                src={URL.createObjectURL(item.file)}
                                            />
                                            <Tooltip title="Delete">
                                                <CloseOutlined
                                                    style={{
                                                        fontSize: "30px",
                                                        position: "absolute",
                                                        right: 5,
                                                        top: 5,
                                                        color: "#c12828",
                                                    }}
                                                    onClick={() => handleDeleteFile(item?.name, files, currentItemFiles, setFiles, setCurrentItemFiles)
                                                    }
                                                />
                                            </Tooltip>
                                        </div>
                                    );
                                })}
                        </Image.PreviewGroup>
                        {files?.length > 0 && <Divider />}
                    </div>
                </>
            )}


            <div style={{ display: "flex", justifyContent: "end" }}>
                {
                    inventoryData?.inventory_adjustments?.length > 0 && (
                        <>
                            {
                                !inventoryData?.posted && (
                                    <>
                                        {(!hasRole5) && (
                                            <>
                                                {allRoutesCompleted ? (
                                                    <Button
                                                        disabled={inventoryData?.posted}
                                                        onClick={() => {
                                                            Modal.confirm({
                                                                title: 'Post Inventory Adjustments',
                                                                centered: true,
                                                                content: `Are you sure you want to post inventory adjustments?`,
                                                                onOk: () => handleSubmit(),
                                                                okText: 'Post',
                                                                width: 600,
                                                                okButtonProps: { size: 'large' },
                                                                cancelButtonProps: { size: 'large' },
                                                            });
                                                        }}
                                                        type="primary"
                                                        size="large"
                                                    >
                                                        Post to Netsuite
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        // disabled
                                                        onClick={() => {
                                                            Modal.error({
                                                                title: 'Action Restricted',
                                                                content: 'Inventory adjustment can not be posted, all stock discrepancies are not posted!',
                                                                centered: true,
                                                                width: 600,
                                                                okButtonProps: { size: 'medium' },
                                                            });
                                                        }}
                                                        type="primary"
                                                        size="large"
                                                    >
                                                        Post to Netsuite
                                                    </Button>
                                                )}

                                            </>
                                        )}
                                    </>
                                )
                            }
                        </>
                    )
                }


            </div>

            <ProductInfoModal
                visible={modalVisibleProduct}
                onCancel={handleModalCancelProduct}
                selectedItemDetails={selectedProductDetails}
                selectedItems={selectedProductDetails?.productDetails}
                selectedRecord={selectedProductDetails?.selectedRecord}
            />
        </DataSheet>

    )
}

export default RouteInventoryAdjustment